<oui-error-page pageTitle="Accès refusé" image="stop">
  Vous n'êtes pas autorisé à accéder à cette page. <br />
  Veuillez vous authentifier avec un compte ayant le bon niveau de droits ou contacter un administrateur.

  <oui-button (click)="onLogout()">Déconnecter</oui-button>
</oui-error-page>
